"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    alignLeft: {
      marginRight: ".5rem",
      "&:last-child": {
        marginRight: "0"
      }
    },
    alignRight: {
      marginLeft: ".5rem",
      "&:first-child": {
        marginLeft: "0"
      }
    },
    alignCenter: {
      margin: "0 .25rem",
      "&:first-child": {
        marginLeft: "0"
      },
      "&:last-child": {
        marginRight: "0"
      }
    },
    rightButtons: {
      textAlign: "right"
    },
    justifiedButtons: {
      display: "flex",
      flex: "1 1 auto"
    },
    centerButtons: {
      textAlign: "center"
    },
    splitButton: {
      flexGrow: "1",
      margin: "0 .25rem",
      "&:first-child": {
        marginLeft: "0"
      },
      "&:last-child": {
        marginRight: "0"
      }
    },
    stackedButton: {
      width: "100%",
      marginBottom: ".5rem"
    }
  };
};

exports.styles = styles;